import React from "react";
import { SlideInOut } from "../../../styles/animations";
import { CollapseContainer } from "..";

export const Collapse = ({
  show,
  parent,
  children,
  marginBottom = "0",
  width = "auto",
  flex = "initial"
}) => {
  return (
    <CollapseContainer width={width} flex={flex}>
      {parent}
      <SlideInOut isOpen={show} marginBottom={marginBottom}>
        {children}
      </SlideInOut>
    </CollapseContainer>
  );
};
